import * as React from "react";

export type EnvironmentType = {
  label: string;
  IDPUrl: string;
  restAPIUrl: string;
};

export type EnvironmentsContextState = {
  environments: EnvironmentType[];

  customEnvironments: EnvironmentType[];
  setCustomEnvironments: (env: EnvironmentType[]) => void;

  authEnvironment: EnvironmentType;
  setAuthEnvironment: (env: EnvironmentType) => void;
};

export const EnvironmentsContext = React.createContext<
  EnvironmentsContextState | undefined
>(undefined);

export const useEnvironments = () => {
  const context = React.useContext(EnvironmentsContext);
  if (context === undefined) {
    throw new Error(
      "useEnvironments must be used within a EnvironmentsProvider"
    );
  }
  return context;
};
